import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaGithub, FaLinkedin, FaBars, FaTimes } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
import { SiChessdotcom } from 'react-icons/si';

function Navbar() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-left">
          <Link to="/" className="navbar-logo" onClick={closeMenu}>JR.</Link>
          <div className={`navbar-links ${menuOpen ? 'active' : ''}`}>
            <Link to="/" className={`nav-link ${location.pathname === '/' ? 'active' : ''}`} onClick={closeMenu}>Feed</Link>
            <Link to="/research" className={`nav-link ${location.pathname === '/research' ? 'active' : ''}`} onClick={closeMenu}>Research</Link>
            <Link to="/adventures" className={`nav-link ${location.pathname === '/adventures' ? 'active' : ''}`} onClick={closeMenu}>Adventures</Link>
          </div>
        </div>       
        <div className="navbar-right">
          <a href="mailto:joshrubow@outlook.com" className="nav-icon"><MdEmail /></a>
          <a href="https://www.chess.com/member/joshrubow" target="_blank" rel="noreferrer" className="nav-icon"><SiChessdotcom /></a>
          <a href="https://www.github.com/jrubow" target="_blank" rel="noreferrer" className="nav-icon"><FaGithub /></a>
          <a href="https://www.linkedin.com/in/josh-rubow/" target="_blank" rel="noreferrer" className="nav-icon"><FaLinkedin /></a>
          <div className="mobile-menu-icon" onClick={toggleMenu}>
            {menuOpen ? <FaTimes /> : <FaBars />}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;